import React from 'react';
import { Container, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as FooterLogo } from '../assets/img/lumio.svg';

const useStyles = makeStyles((theme) => ({
    footerWrapper: {
        width: "100%",
        height: 60,
        display: "flex",
        alignItems: "center",
        bottom: 0,
        backgroundColor: theme.custom.colors.baseBgColor,
        borderTop: "1px solid",
        borderColor: theme.custom.colors.borderLight
    },
    footerContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    footerNav: {
        margin: "0 -16px"
    },
    footerNavItem: {
        padding: "0 16px",
        color: theme.custom.colors.fontDark
    },
    footerLogo: {
        width: 64,
        height: 20
    }
}));

const Footer = () => {
    const classes = useStyles();

    return (
        <footer className={classes.footerWrapper}>
            <Container maxWidth="md">
                <div className={classes.footerContainer}>   
                    <div className={classes.footerNav}>
                        <Link href="https://help.lumio.id/drop" target="_blank" rel="noopener" variant="body2" className={classes.footerNavItem}>
                            Help
                        </Link>
                        <Link href="https://www.lumio.id" target="_blank" rel="noopener" variant="body2" className={classes.footerNavItem}>
                            About
                        </Link>
                    </div>
                    <a href="https://www.lumio.id" target="_blank" rel="noopener noreferrer">
                        <FooterLogo className={ `${classes.footerLogo} footer-logo`}/>
                    </a>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;